module.exports = __webpack_public_path__ + "static/media/rm_06-13.d9a4edaa.png";